import State from '../core/State';
import initialState from '../initialState';
import User from '../entity/User';

export const startAuthentication = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    fetching: state.authentication.fetching + 1,
  },
});

export const finishAuthentication = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    fetching: state.authentication.fetching - 1,
  },
});

export const setSignedInUser = (user: User) => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    signedInUser: user,
  },
});

export const disposeUser = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    signedInUser: initialState.authentication.signedInUser,
  },
});
